import React from 'react'
import './Common_Title_1.css'
import { Link } from 'react-router-dom'

const Common_Title_1 = ({ titleText, subText, link, footerText }) => {
  return (
    <div className='Common_Title_1'>
      <div className='main_div'>
        <div className='left_holder'>
          <h3 className='title_text'>{titleText}</h3>
          <p className='sub_text'>{subText}</p>
        </div>
      </div>
    </div>
  )
}

export default Common_Title_1
